import { Link, useLocation, useParams } from "react-router-dom";
import { getCityBySlug } from "@/data/cities";

const Footer = () => {
  const location = useLocation();
  const match = location.pathname.match(/^\/cities\/([^/]+)/);
  const slug = match?.[1];
  const city = slug ? getCityBySlug(slug) : null;
  const showCcpa = city?.stateCode === "CA";

  return (
    <footer className="border-t py-8 mt-auto">
      <div className="container mx-auto px-4 text-center text-sm text-muted-foreground space-y-2">
        <p>© {new Date().getFullYear()} BestPriceRide.com — All rights reserved.</p>
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-2">
          <Link to="/about" className="hover:text-primary hover:underline">About</Link>
          <Link to="/premium" className="hover:text-primary hover:underline">Premium</Link>
          <Link to="/terms" className="hover:text-primary hover:underline">Terms of Service</Link>
          <Link to="/privacy" className="hover:text-primary hover:underline">Privacy Policy</Link>
          {showCcpa && (
            <Link to="/ccpa" className="hover:text-primary hover:underline">CCPA Notice</Link>
          )}
          <Link to="/provider-agreement" className="hover:text-primary hover:underline">Provider Agreement</Link>
          <Link to="/cookies" className="hover:text-primary hover:underline">Cookie Policy</Link>
          <Link to="/disclaimer" className="hover:text-primary hover:underline">Disclaimer</Link>
          <Link to="/rider-terms" className="hover:text-primary hover:underline">Rider Terms</Link>
          <Link to="/code-of-conduct" className="hover:text-primary hover:underline">Code of Conduct</Link>
          <Link to="/refunds" className="hover:text-primary hover:underline">Refund Policy</Link>
          <Link to="/contact" className="hover:text-primary hover:underline">Contact</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
